import { htmlSanitizer } from 'utils/sanitizer';

function stripHtml(htmlString: string): string {
  const el = document.createElement('div');
  el.insertAdjacentHTML('beforeend', htmlSanitizer(htmlString.replace('&nbsp;', '')));
  return el.textContent ?? '';
}

export { stripHtml };
